import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface CreditMemoReportRequest {
  supplierNo: string;
  claimSeqNumber: string;
}

@Injectable({ providedIn: 'root' })
export class ContractReportService {
  private readonly baseUrl = `${environment.restApiUrl}reports`;

  constructor(private http: HttpClient) {}

  /** Fetch the credit-memo contract report as a binary PDF Blob. */
  getCreditMemoPdf(request: CreditMemoReportRequest): Observable<Blob> {
    return this.http.post(`${this.baseUrl}/cm/pdf`, request, {
      responseType: 'blob',
    });
  }
}
